import { cva } from 'class-variance-authority';

/** L'habit commun d'`IconButton` et d'`IconLink`. */
export const iconButtonVariants = cva(
  [
    'relative inline-flex shrink-0 items-center justify-center rounded-pill',
    'transition-[background-color,color,opacity] duration-150 ease-settle',
    'disabled:pointer-events-none disabled:opacity-35',
  ],
  {
    variants: {
      /**
       * `plain` : l'icône nue, noire, sans pastille — le cas général.
       * `filled` : le bouton retour posé sur un média, et rien d'autre.
       * `scrim` : sur une photo claire. `stage` : sur une vidéo, dans la scène.
       */
      variant: {
        plain: 'text-fg hover:bg-fill active:bg-fill-hover',
        filled: 'bg-fill text-fg hover:bg-fill-hover',
        scrim: 'bg-scrim-light text-fg backdrop-blur-sm hover:bg-surface',
        stage: 'text-stage-fg hover:bg-stage-fill',
        stageFilled: 'bg-black/35 text-stage-fg backdrop-blur-md hover:bg-black/50',
      },
      size: {
        sm: 'size-8',
        md: 'size-10',
        lg: 'size-12',
      },
    },
    defaultVariants: { variant: 'plain', size: 'md' },
  },
);

/** Taille du pictogramme pour chaque taille de bouton (partagée avec `IconLink`). */
export const ICON_GLYPH = { sm: 20, md: 23, lg: 26 } as const;
